<template>
  <iframe
    allowfullscreen
    :src="source"
    class="border-0 h-100 w-100"
  ></iframe>
</template>

<script>

export default {
  name: "vis-external-view",
  props: {
    source: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter(to, from, next) {
    to.meta.label = localStorage.getItem(
      to.path
    ) || "Внешний источник"

    next();
  },
  beforeRouteUpdate(to, from, next) {
    to.meta.label = localStorage.getItem(
      to.path
    ) || "Внешний источник"

    next();
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
